<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row mb-3" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <h4 class="mb-2 py-1 font-header-1">Claims</h4>
</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class=" mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-header transparent">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row mt-3">
                                <div class="col-lg-2 me-3 d-inline-flex">
                                    <input type="text" placeholder="Interchange ControlNo"
                                        [(ngModel)]="claimGridlistBo.interchangeControlNumber"
                                        (keyup.enter)="getClaimGridList();"
                                        [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null||global.globalAgencyId==''"
                                        class="form-control" style="padding-right:24px;">
                                    <i class="fa fa-search px-1 fs-5 iconSearch mt-2" (click)="getClaimGridList();"
                                        style="margin-left: -24px;"></i>
                                </div>
                                <div class="col-lg-2  me-3 d-inline-flex">
                                    <input type="text" placeholder="Patient ControlNo"
                                        [(ngModel)]="claimGridlistBo.patientControlNumber"
                                        (keyup.enter)="getClaimGridList();"
                                        [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null||global.globalAgencyId==''"
                                        class="form-control" style="padding-right:24px;">
                                    <i class="fa fa-search px-1 fs-5 iconSearch mt-2" (click)="getClaimGridList();"
                                        style="margin-left: -24px;"></i>
                                </div>

                                <div class="col-lg-2 me-3 d-inline-flex">
                                    <input type="text" placeholder="Payer ClaimControlNo"
                                        [(ngModel)]="claimGridlistBo.payerClaimReferenceNumber"
                                        (keyup.enter)="getClaimGridList()"
                                        [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null||global.globalAgencyId==''"
                                        class="form-control " style="padding-right:24px;">
                                    <i class="fa fa-search px-1 fs-5 iconSearch mt-2" (click)="getClaimGridList();"
                                        style="margin-left: -24px;"></i>
                                </div>

                                <div class="col text-end">
                                    <button type="button" class="btn  btn-sm text_right  mb-1 me-4"
                                        data-bs-toggle="modal" data-bs-target="#exportascsvmodel">
                                        Export as CSV
                                    </button>
                                    <button type="button" class="btn btn-sm" (click)="isViewbatches=true"
                                        data-bs-toggle="modal" data-bs-target="#batchView">View Batch</button>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <!-- Filters Feilds -->
                <div class="card-body mt-2">
                    <div class="col">
                        <div class="row">
                            <div class="col-lg-4 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4">Start Date</label>

                                <my-date-picker [options]="myDatePickerOptions" [selDate]="filterStartDate"
                                    style="width:100%;" placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="payDateChanges($event,'inputchanged','startDate')"
                                    (dateChanged)="payDateChanges($event,'datechanged','startDate')">
                                </my-date-picker>
                            </div>
                            <div class="col-lg-4 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4">End Date</label>

                                <my-date-picker [options]="myDatePickerOptions" [selDate]="filterEndDate"
                                    style="width:100%;" placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="payDateChanges($event,'inputchanged','endDate')"
                                    (dateChanged)="payDateChanges($event,'datechanged','endDate')">
                                </my-date-picker>
                            </div>

                            <div class="col-lg-4 d-flex flex-column mb-2 mt-3">
                                <label class="label-font mb-1">Date Filter</label>
                                <div class="d-flex align-items-center gap-3">
                                    <div class="custom-radio-option me-2"
                                        (click)="svcdateFilterTypeStr = 'true'">
                                        <span class="custom-radio-circle"
                                            [class.selected]="svcdateFilterTypeStr === 'true'"></span>
                                        <span class="custom-radio-label">Service Date</span>
                                    </div>
                                    <div class="custom-radio-option"
                                        (click)="svcdateFilterTypeStr = 'false'">
                                        <span class="custom-radio-circle"
                                            [class.selected]="svcdateFilterTypeStr === 'false'"></span>
                                        <span class="custom-radio-label">Prepared Date</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-11 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4">Payment Status</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="paymentstatus"
                                    bindLabel="lovName" bindValue="lovName"
                                    [(ngModel)]="claimGridlistBo.claimpaymentstatus">
                                </ng-select>
                            </div>


                            <div class="col-lg-4  col-11 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4 col-4">Client</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="AllClientList"
                                    bindLabel="Value" bindValue="Key" [(ngModel)]="claimGridlistBo.clientId">
                                </ng-select>
                            </div>
                            <div class="col-lg-4 col-11 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4 col-4">Employee</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="AllEmployeeList"
                                    bindLabel="Value" bindValue="Key" [(ngModel)]="claimGridlistBo.employeeId">
                                </ng-select>
                            </div>


                            <div class="col-lg-4 col-11 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4 col-4">Service</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="serviceList"
                                    bindLabel="Value" bindValue="Key" [(ngModel)]="claimGridlistBo.serviceId">
                                </ng-select>
                            </div>

                            <div class="col-lg-3 col-11 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4 col-4">Resubmission</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="ResubmissionList"
                                    bindLabel="lovName" bindValue="id"
                                    [(ngModel)]="claimGridlistBo.resubmissionTypeLid">
                                </ng-select>
                            </div>

                            <div class="col-lg-3 col-11 d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4 col-4">Payer</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="AllpayerList"
                                    bindLabel="Value" bindValue="Key" [(ngModel)]="claimGridlistBo.payerId">
                                </ng-select>
                            </div>
                            <div class="col-lg-3  col-11 d-flex mb-2 mt-3">
                                <label class=" label-font col-lg-4 col-4">Company</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="AllCompanyList"
                                    bindLabel="Value" bindValue="Key" [(ngModel)]="claimGridlistBo.companyId">
                                </ng-select>
                            </div>
                            <div class="col-lg-3 col-11  d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4 col-4">Claim Type</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="claimstype"
                                    bindLabel="lovName" bindValue="lovName" [(ngModel)]="claimGridlistBo.claimType">
                                </ng-select>
                            </div>
                            <!-- <div class="col-lg-3 col-11  d-flex mb-2 mt-3">
                                <input type="radio" class="ms-1" name="All" value=true
                                    [(ngModel)]="claimGridlistBo.csg" (change)="getClaimGridList()"> &nbsp; CSG
                            </div> -->
                            <!-- <div class="col-lg-3 col-11  d-flex mb-2 mt-3">
                                <label class="label-font col-lg-4 col-4">Claim Status</label>
                                <ng-select class="col" [searchable]="true" [clearable]="true" [items]="claimstype"
                                    bindLabel="lovName" bindValue="lovName" [(ngModel)]="claimGridlistBo.claimStatus">
                                </ng-select>
                            </div> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col  mt-2">
                            <div class="text-end">
                                <button type="button" class="btn btn-sm" (click)="filterClaim()">Apply
                                </button>
                                <button type="button" class="btn btn-sm ms-lg-5 ms-3" (click)="RefreshClaim()">Refresh
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class=" mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body transparent  text-muted">

                    <div class="col">
                        <div class="row">

                            <div class="col-lg-3 col-11 d-flex">
                                <label class="label-font col-5">Clearing House</label>
                                <ng-select class="w-100" [searchable]="true" [clearable]="true"
                                    [items]="ClearingHouseList" bindLabel="Value" bindValue="Key"
                                    [(ngModel)]="saveBatchFileBO.clearingHouseId">
                                </ng-select>
                            </div>
                            <div class="col-5 d-flex">

                            </div>

                            <div class="col-lg-4 d-flex justify-content-end">
                                <!-- Move to archive -->
                                <button type="button" class="btn btn-sm me-5" *ngIf="activeTab == 'active' && fp.activeclaimsmovetoachieve"  (click)="MovetoArchive()"   [disabled]="SelectedClaimCheckBox.length==0 || IsButtonDisable" >
                                    Move to archive 
                                </button>
                                <button type="button" class="btn btn-sm me-5" *ngIf="activeTab == 'archive' && fp.achieveclaimsmovetoactive" (click)="RestoreActive()" [disabled]="SelectedClaimCheckBox.length==0 || IsButtonDisable" >
                                    Restore to active
                                </button>
                                <button class="btn btn-sm me-5" data-bs-target="#deleteMultiTimesheet"
                                    *ngIf="activeTab == 'readyToBill' && fp.readytobillmultipledelete"
                                    data-bs-toggle="modal" [disabled]="SelectedClaimCheckBox.length==0">
                                    Delete
                                </button>
                                <button class="btn btn-sm me-5" data-bs-target="#deleteMultiTimesheet"
                                    *ngIf="activeTab == 'active' && fp.activeclaimsmultipledelete"
                                    data-bs-toggle="modal" [disabled]="SelectedClaimCheckBox.length==0">
                                    Delete
                                </button>
                                <button class="btn btn-sm me-5" data-bs-target="#deleteMultiTimesheet"
                                    *ngIf="activeTab == 'archive' && fp.achieveclaimsmultipledelete"
                                    data-bs-toggle="modal" [disabled]="SelectedClaimCheckBox.length==0">
                                    Delete
                                </button>
                                <button class="btn btn-sm me-5" data-bs-target="#deleteMultiTimesheet"
                                    *ngIf="activeTab == 'resubmit' && fp.resubmitclaimsmultipledelete"
                                    data-bs-toggle="modal" [disabled]="SelectedClaimCheckBox.length==0">
                                    Delete
                                </button>

                                <button type="button" class="btn btn-sm me-2" (click)="saveBatchFile837()"
                                    *ngIf="activeTab == 'readyToBill' && fp.readytobillcreate" [disabled]="IsButtonDisable || saveBatchFileBO.clearingHouseId==null ||saveBatchFileBO.clearingHouseId==undefined ||saveBatchFileBO.clearingHouseId==''
                            ||SelectedClaimCheckBox.length==0">Create</button>
                                <button type="button" class="btn btn-sm me-2"
                                    *ngIf="activeTab == 'active' && fp.activeclaimscreate" (click)="saveBatchFile837()"
                                    [disabled]="IsButtonDisable || saveBatchFileBO.clearingHouseId==null ||saveBatchFileBO.clearingHouseId==undefined ||saveBatchFileBO.clearingHouseId==''
                            ||SelectedClaimCheckBox.length==0">Create</button>
                                <button type="button" class="btn btn-sm me-2"
                                    *ngIf="activeTab == 'archive' && fp.achieveclaimscreate"
                                    (click)="saveBatchFile837()" [disabled]="IsButtonDisable || saveBatchFileBO.clearingHouseId==null ||saveBatchFileBO.clearingHouseId==undefined ||saveBatchFileBO.clearingHouseId==''
                            ||SelectedClaimCheckBox.length==0">Create</button>
                                <button type="button" class="btn btn-sm me-2"
                                    *ngIf="activeTab == 'resubmit' && fp.resubmitclaimscreate"
                                    (click)="saveBatchFile837()" [disabled]="IsButtonDisable || saveBatchFileBO.clearingHouseId==null ||saveBatchFileBO.clearingHouseId==undefined ||saveBatchFileBO.clearingHouseId==''
                            ||SelectedClaimCheckBox.length==0">Create</button>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="card-body">

                    <div class="row mb-2">
                        <div class="col p-0">
                            <div widget class="card border-0 box-shadow p-0">
                                <div class="row px-1">
                                    <div class="col-lg-12 col-md-12">
                                        <nav *ngIf="!global.docbool">
                                            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                                <a class="nav-item nav-link active" [ngClass]="{'mytab-inactive':
                                                    activeTab!='readyToBill',
                                                    'active': activeTab=='readyToBill'}" id="nav-readytobill-tab"
                                                    data-bs-toggle="tab" href="#nav-readytobill" role="tab"
                                                    aria-controls="nav-readytobill" aria-selected="true"
                                                    (click)="getActiveTab('readyToBill')">Ready To
                                                    Bill</a>
                                                <a class="nav-item nav-link" [ngClass]="{'mytab-inactive':
                                                activeTab!='active',
                                                    'active':activeTab=='active' }" id="nav-active-tab"
                                                    data-bs-toggle="tab" href="#nav-active" role="tab"
                                                    aria-controls="nav-active" aria-selected="true"
                                                    (click)="getActiveTab('active')">Active</a>
                                                <a class="nav-item nav-link" [ngClass]="{'mytab-inactive':
                                                    activeTab!='archive',
                                                        'active': activeTab=='archive'}" id="nav-archive-tab"
                                                    data-bs-toggle="tab" href="#nav-archive" role="tab"
                                                    aria-controls="nav-archive" aria-selected="true"
                                                    (click)="getActiveTab('archive')">Archive</a>
                                                <a class="nav-item nav-link" [ngClass]="{'mytab-inactive':
                                                    activeTab!='resubmit',
                                                        'active': activeTab=='resubmit'}" id="nav-resubmit-tab"
                                                    data-bs-toggle="tab" href="#nav-resubmit" role="tab"
                                                    aria-controls="nav-resubmit" aria-selected="true"
                                                    (click)="getActiveTab('resubmit')">ReSubmitted</a>
                                            </div>
                                        </nav>
                                        <div class="tab-content" id="nav-tabContent">
                                            <div class="my-3">
                                                <ejs-grid #cliamsGrid id="cliamsGrid"
                                                    [dataSource]='ClaimsListGrid | async' [allowPaging]='true'
                                                    [pageSettings]='initialPage' [filterSettings]='filterSettings'
                                                    [allowFiltering]='true' [allowResizing]='true'
                                                    [showColumnChooser]='true' [allowSorting]='true'
                                                    (checkBoxChange)="checkBoxClick($event)"
                                                    [selectionSettings]='selectionOptions'
                                                    (dataStateChange)='dataStateChange($event)'
                                                    (actionBegin)="onActionComplete($event)"
                                                    height='400'>

                                                    <e-columns>
                                                        <e-column type='checkbox' uid="checkbox" maxWidth=50
                                                            [allowEditing]='true' editType="booleanedit"
                                                            [showInColumnChooser]='false'>
                                                        </e-column>
                                                        <e-column maxWidth=100 headerText="Actions"
                                                            [showInColumnChooser]='false'>
                                                            <ng-template #template let-data>
                                                                <button class="btn btn-edit-table mx-2 text-center"
                                                                    (click)="ClaimEmitpage(data)"
                                                                    *ngIf="fp.readytobillupdate && activeTab=='readyToBill'">
                                                                    <i class="fa fa-edit"></i></button>
                                                                <button class="btn btn-delete-table"
                                                                    (click)="getClaimId(data.id)" data-bs-toggle="modal"
                                                                    data-bs-target="#DeleteClaim"
                                                                    *ngIf="fp.readytobilldelete && activeTab=='readyToBill'"><i
                                                                        class="fa fa-trash"></i></button>
                                                                <button class="btn btn-edit-table mx-2 text-center"
                                                                    (click)="ClaimEmitpage(data)"
                                                                    *ngIf="fp.activeclaimsupdate && activeTab=='active'">
                                                                    <i class="fa fa-edit"></i></button>
                                                                <button class="btn btn-delete-table"
                                                                    (click)="getClaimId(data.id)" data-bs-toggle="modal"
                                                                    data-bs-target="#DeleteClaim"
                                                                    *ngIf="fp.activeclaimsdelete && activeTab=='active'"><i
                                                                        class="fa fa-trash"></i></button>
                                                                <button class="btn btn-edit-table mx-2 text-center"
                                                                    (click)="ClaimEmitpage(data)"
                                                                    *ngIf="fp.achieveclaimsupdate && activeTab=='archive'">
                                                                    <i class="fa fa-edit"></i></button>
                                                                <button class="btn btn-delete-table"
                                                                    (click)="getClaimId(data.id)" data-bs-toggle="modal"
                                                                    data-bs-target="#DeleteClaim"
                                                                    *ngIf="fp.achieveclaimsdelete && activeTab=='archive'"><i
                                                                        class="fa fa-trash"></i></button>
                                                                <button class="btn btn-edit-table mx-2 text-center"
                                                                    (click)="ClaimEmitpage(data)"
                                                                    *ngIf="fp.resubmitclaimsupdate && activeTab=='resubmit'">
                                                                    <i class="fa fa-edit"></i></button>
                                                                <button class="btn btn-delete-table"
                                                                    (click)="getClaimId(data.id)" data-bs-toggle="modal"
                                                                    data-bs-target="#DeleteClaim"
                                                                    *ngIf="fp.resubmitclaimsdelete && activeTab=='resubmit'"><i
                                                                        class="fa fa-trash"></i></button>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=100 field="clientName"
                                                            headerText="Client Name" type="string">
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>

                                                        <e-column minWidth=100 field="claimDate" headerText="Service Date" [allowFiltering]="false"
                                                            type="date" [format]="formatOptions">
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox
                                                                    placeholder="Enter the value"></ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>                        
                                                        <e-column field='companyName' headerText="Company" minWidth=130
                                                            [allowEditing]='false' type='string'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column field='payerName' headerText="Payor" minWidth=100
                                                            [allowEditing]='false' type='string'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=100 field="preparedDate" headerText="Prepared Date" [allowFiltering]="false"
                                                            type="date" [format]="formatOptions">
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox
                                                                    placeholder="Enter the value"></ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column field='claimNote' headerText="Notes" minWidth=100
                                                            [allowEditing]='false' type='string'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column field='serviceCodeToDisplay' headerText="Service"
                                                            minWidth=130 type="string" [allowEditing]='false'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column field='claimType' headerText="Claim Type" minWidth=130
                                                            type="string" [allowEditing]='false'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=100 field="totalAmount"
                                                            headerText="Total Amount" type="number">
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=100 field="paidAmount"
                                                            headerText="Paid Amount" type="number">
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=100 field="balanceDueAmount"
                                                            headerText="Balance Due" type="number">
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column field='patientControlNumbersString'
                                                            headerText="Patient ControlNumbers" minWidth=130
                                                            type="string" [allowEditing]='false'
                                                            [allowFiltering]='false'>
                                                        </e-column>
                                                        <e-column field='interchangeControlNumbersString'
                                                            headerText="Interchange ControlNumbers" minWidth=130
                                                            type="string" [allowEditing]='false'
                                                            [allowFiltering]='false'>
                                                        </e-column>
                                                        <e-column field='payerClaimControl'
                                                            headerText="PayerClaim ControlNumbers" minWidth=130
                                                            type="string" [allowEditing]='false'
                                                            [allowFiltering]='false'>
                                                        </e-column>

                                                        <e-column field='clientLocation' headerText="Location"
                                                            minWidth=130 type="string" [allowEditing]='false'
                                                            [allowFiltering]='false'>
                                                        </e-column>
                                                        <e-column field='paymentStatus' headerText="Payment Status"
                                                            minWidth=130 type="string" [allowEditing]='false'
                                                            [allowFiltering]='false'>
                                                        </e-column>


                                                        <e-column field='resubmissionTypeLidName'
                                                            headerText="Resubmission Type" minWidth=130 type="string"
                                                            [allowEditing]='false' [allowFiltering]='false'>
                                                        </e-column>


                                                        <e-column width="50" [showInColumnChooser]='false'>
                                                            <ng-template #headerTemplate let-data>
                                                                <div>
                                                                    <span id='show' (click)='showClaimsGridColumns()'><i
                                                                            class="fa fa-cog fa-lg" aria-hidden="true">
                                                                        </i></span>
                                                                </div>
                                                            </ng-template>
                                                        </e-column>
                                                    </e-columns>
                                                </ejs-grid>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<span id="deleteClaimModal" data-bs-toggle="modal" data-bs-target="#DeleteClaim"></span>
<div class="modal fade modalbackgrod" id="DeleteClaim" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Delete Claim </span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="cancelDelete()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">

                <label class="mx-auto" style="font-size: 12px;">
                    Do you want to Delete this Claim File</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="IsButtonDisable" (click)="deleteClaim()">Delete</button>
                <button type="button" class="btn btn-sm ms-2" data-bs-dismiss="modal"
                    (click)="cancelDelete()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<span id="viewBatchOpen" data-bs-toggle="modal" data-bs-target="#batchView"></span>
<div class="modal fade" id="batchView" data-bs-backdrop="static" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Batch Details</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeViewBatch()"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12 ml-3">
                        <app-viewbatch *ngIf="isViewbatches"></app-viewbatch>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
                    (click)="closeViewBatch()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- exportascsvmodel -->

<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Export as CSV</h5>
                
                <button type="button" class="btn-close"  data-bs-dismiss="modal" aria-label="Close">
                   
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="exportClaimsCurrentCsv()">
                            Print Current page
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="exportClaimsCsv()">
                            Print All page
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<!------------------------------------------------- Delete Multiple timesheet------------------------------------------------------>
<span id="Multidelete" data-bs-target="#deleteMultiTimesheet" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteMultiTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    Delete Claim
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">
                </button>
            </div>
            <div class="modal-body">

                <label class="mx-auto" style="font-size: 12px;">
                    Do you want to Delete this Claim File</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="IsButtonDisable" (click)="multipledeleteClaim()">Delete</button>
                <button type="button" class="btn btn-sm ms-2" data-bs-dismiss="modal"
                    (click)="cancelmultidelete()">Cancel</button>
            </div>

        </div>
    </div>
</div>